import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

import { Invitation } from '@model/Invitation';
import { Paginate } from '@model/Paginate';

@Injectable({
  providedIn: 'root'
})
export class InvitationsService {
  constructor(private http: HttpClient) {}

  paginate(page: number, per_page: number): Observable<Paginate<Invitation>> {
    return this.http.get<Paginate<Invitation>>(
      `${environment.base_url}/invitations/invitations_by_user?page=${page}&per_page=${per_page}`
    );
  }

  accept(id: number): Observable<any> {
    return this.http.get(`${environment.base_url}/invitations/${id}/accept`);
  }

  reject(id: number): Observable<any> {
    return this.http.delete(`${environment.base_url}/invitations/${id}`);
  }
}
